import { dataAttributeProps } from '@pbk-web/utils';
import type { FC } from 'react';
import { useMemo } from 'react';

import gradientSvg from '../../assets/images/gradient.svg';
import UserIcon from '../icons/misc/UserIcon';

type Props = {
  firstName: string;
  lastName: string;
  id?: string;
  isCurrentUser?: boolean;
  sizeCss?: string;
  marginCss?: string;
  className?: string;
};

const ProfileInitials: FC<Props> = (props) => {
  const { id, firstName, lastName, sizeCss = 'w-8 h-8 text-pbk-14', marginCss, className, isCurrentUser = false } = props;

  const initials = useMemo(() => {
    return (firstName?.charAt(0).toUpperCase() || '') + (lastName?.charAt(0).toUpperCase() || '');
  }, [firstName, lastName]);

  return (
    <div
      className={`${sizeCss} rounded-full p-[2px] shadow-md transition-all duration-300 ease-in-out hover:z-20 [&:is([data-user-count]):not([data-user-count="0"]):not([data-user-count="1"])]:hover:-mt-[0.3rem] ${marginCss}`}
      style={{
        backgroundImage: id ? `url("${gradientSvg}")` : '',
        backgroundColor: id ? '' : 'rgba(var(--pbk-color-greyscale-15), 1)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '125%',
        backgroundPosition: 'center',
      }}
      {...dataAttributeProps(props)}
    >
      <div
        className={`${className} ${
          id ? (isCurrentUser ? 'bg-accent-1-100 text-white' : 'text-text-2 bg-white') : 'bg-greyscale-15 text-black'
        } inline-flex h-full w-full cursor-default items-center justify-center rounded-full border-2 border-transparent pt-[2px] font-medium select-none`}
      >
        {initials || <UserIcon className="text-text-2" />}
      </div>
    </div>
  );
};

export default ProfileInitials;
